import React, { Fragment, useState, useEffect, useRef, useContext } from "react";



//************** Componentes PrimerReact **************/
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';


//************** Componentes generales **************/
import Card from "../../../../Base/Components/Card/Card";
import Loader from "../../../../Base/Components/Loader/Loader";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

//************** Consultas API **************/
import {cambiarCountry, cambiarEstadoCustomerD, getCustomerDetails, getCustomerDetailsIPS, GuardarCustomerDetails, putChecksCustomerDetails, putStatusCustomerDetails } from '../../../../Base/API/Clientes/ClientesRequest';

//************** Componentes Especificos **************/
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { Dropdown } from "primereact/dropdown";
import { getEstadosCategoryIPS } from "../../../API/Global/Estados/StatusRequest";
import { toastShow } from "../../../Services/ToastService";
import { getPaises } from "../../../API/Global/Paises/PaisesRequest";
import { getIn } from "formik";


const ModalClientesDetails = ({ IdCustomer, clientesDetailsDialog, setClientesDetailsDialog }) => {

    // const [clientesDetailsDialog, setClientesDetailsDialog] = useState(false);
    // const [clienteDetalleDialog, setClienteDetalleDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);
    const [detalles, setDetalles] = useState([]);
    const toast = useRef(null);
    const [habilitar, setHabilitar] = useState(false)
    const [selected, setSelected] = useState([])
    const [estados, setEstados] = useState([])
    const [paises, setPaises] = useState([])
    const {userAuth} = useContext(AuthContext);

    const getInfo = async () => {
        setLoading(true)
        setSelected([])
        setDetalles([])
        const result = await getCustomerDetailsIPS(IdCustomer)

        const estadosTempo = await getEstadosCategoryIPS('Customer')
        setEstados(estadosTempo)

        const paisesTempo = await getPaises()
        setPaises(paisesTempo)


        
        setDetalles(result)
        setLoading(false)
    }
    

    const onChangeCheck = async (valor, IdDCustomer, e) => {
        if(IdDCustomer > 0){
            let checkValores = {
                Valor: valor,
                Activo: e,
                IdDCustomer: IdDCustomer,
                IdCustomer: IdCustomer
            }
    
    
            setLoading(true)
            const result = await putChecksCustomerDetails(checkValores)
            // const temporal = result.map((item) => {
            //     // console.log(item)
            //     if (item.id === IdDCustomer) {
            //         item.IsShipTo = true
            //     }
            //     return item
            // })
    
            // setDetalles(temporal)
            getInfo()
            setLoading(false)
        }else{
            setDetalles(prevDetalles =>
                prevDetalles.map(detail => {
                    if (detail.IdDCustomer === IdDCustomer) {
                        let updatedDetail = { ...detail };
                        if (valor === 1) updatedDetail.IsBuyer = e;
                        if (valor === 2) updatedDetail.IsShipTo = e;
                        if (valor === 3) updatedDetail.IsBillTo = e;
                        return updatedDetail;
                    }
                    return detail;
                })
            );
        }
    }


    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Cancelado', detail: 'Cambio de estado cancelado', life: 3000 });
    }

    const putStatus = async(datosCliente) =>{
        const result = await putStatusCustomerDetails(datosCliente)
       
        setDetalles(result)

       

        datosCliente.IdStatus === 2 ? setHabilitar(true) : setHabilitar(false) 
    } 


    const cancelarCliente = async (rowData,valor) =>{
       
      
        let datosCliente = {
            IdCustomer: rowData.IdCustomer,
            IdDCustomer: rowData.IdDCustomer,
            IdStatus: valor
        }

        confirmDialog({
            message: '¿Está seguro que desea cambiar el estado del cliente?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept : () => putStatus(datosCliente),
            reject:  reject
        });

       
  
    }

    const botones = (rowData) => {
        // console.log(rowData)
        return (
            <div className='col-12 d-flex' style={{ textAlign: 'center', height: 28, marginTop: -6 }}>
                {/* <ModalAEClientesDetalle
                    datos={rowData}
                    toast={toast}
                    icono={aspectoBoton[1].Icono}
                    nombre={aspectoBoton[1].Nombre}
                    className={aspectoBoton[1].className}
                    obtenerCustomerDetails={obtenerCustomerDetails}
                    // clienteDetalleDialog={clienteDetalleDialog}
                    // setClienteDetalleDialog={ setClienteDetalleDialog}
                /> */}
                <Button label={''} className='p-button-rounded p-button-info p-button-text' icon='ri-close-circle-line' style={{ color: "red" }}
                onClick={() =>cancelarCliente(rowData, 2)} disabled={habilitar}/>
                <Button label={''} className='p-button-rounded p-button-info p-button-text' icon='ri-checkbox-circle-fill' style={{ color: "green" }}
                onClick={() =>cancelarCliente(rowData, 1)} disabled={!habilitar}/>
            </div>

        )
    }

    const changeEstado = ({ data, oldValue, api }, column) => {
        return (
            <div>
            <Dropdown
                value={estados.find((e) => e.IdStatus === data?.IdStatus)[0]}
                options={estados}
                style={{ width: "100%", position: "relative" }}
                optionLabel="StatusName"
                filter
                filterBy="StatusName"
                clearIcon="pi pi-times"
                onChange={(e) => {
                    if(data?.IdDCustomer > 0){
                        confirmDialog({
                            message: "¿Desea cambiar el estado?",
                            header: "Cambiar Estado",
                            icon: "pi pi-exclamation-triangle",
                            acceptLabel: "Sí",
                            rejectLabel: "No",
                            style: { backgroundColor: "white" },
                            accept: async () => {
                                setLoading(true)
                                let Ids
                                let IdStatus = e.value?.IdStatus;
                                if(selected?.length > 0){
                                    Ids = selected.map(item => item.IdDCustomer).join(",");
                                }else{
                                    Ids = data?.IdDCustomer
                                }
    
                                const resp = await cambiarEstadoCustomerD(IdStatus, Ids)
                                console.log(resp);
                                if(resp){
                                  toastShow(toast, "success", 'Cambiado',"Estado cambiado exitosamentee");
                                  setSelected([])
                                  getInfo()
                                }else{
                                  toastShow(toast, "error", "Error al cambiar estado de la Hilaza");
                                }
                                setLoading(false)
                            },
                            reject: () => {},
                        });
                    }else{
                        let tempo2 = [...detalles];
                        const index = tempo2.findIndex((detail) => detail.IdDCustomer === data.IdDCustomer);
                        if (index !== -1) {
                            tempo2[index] = { 
                                ...tempo2[index], 
                                IdStatus: e.value.IdStatus, 
                                StatusName: e.value.StatusName 
                            };
                            setDetalles(tempo2);
                        }

                    }
                }}
            />
            </div>
        );
    };
    
    const changePais = ({ data, oldValue, api }, column) => {
        return (
            <div>
            <Dropdown
                value={paises.find((e) => e.IdCountry === data?.IdCountry)}
                options={paises}
                style={{ width: "100%", position: "relative" }}
                optionLabel="Name"
                filter
                filterBy="Name"
                clearIcon="pi pi-times"
                onChange={(e) => {
                    if(data?.IdDCustomer > 0){
                        confirmDialog({
                            message: "¿Desea cambiar el país?",
                            header: "Cambiar País",
                            icon: "pi pi-exclamation-triangle",
                            acceptLabel: "Sí",
                            rejectLabel: "No",
                            style: { backgroundColor: "white" },
                            accept: async () => {
                                setLoading(true)
                                let Ids
                                let IdCountry = e.value?.Id;
                                if(selected?.length > 0){
                                    Ids = selected.map(item => item.IdDCustomer).join(",");
                                }else{
                                    Ids = data?.IdDCustomer
                                }
    
                                const resp = await cambiarCountry(IdCountry, Ids)
                                if(resp){
                                  toastShow(toast, "success", 'Cambiado',"País cambiado exitosamentee");
                                  setSelected([])
                                  getInfo()
                                }else{
                                  toastShow(toast, "error", "Error al cambiar país");
                                }
                                setLoading(false)
                            },
                            reject: () => {},
                        });
                    }else{
                        let tempo2 = [...detalles];
                        const index = tempo2.findIndex((detail) => detail.IdDCustomer === data.IdDCustomer);
                        if (index !== -1) {
                            tempo2[index] = { 
                                ...tempo2[index], 
                                IdCountry: e.value.Id, 
                                CountryName: e.value.Name 
                            };
                            setDetalles(tempo2);
                        }

                    }
                    
                }}
            />
            </div>
        );
    };

    const changeValue = ({ data, column }) => {
        const index = detalles.findIndex((detail) => detail.IdDCustomer === data.IdDCustomer);
        
        if (index !== -1) {
            let newDetails = [...detalles];
            newDetails[index] = { ...newDetails[index], [column.field]: data[column.field] };
            setDetalles(newDetails);
        }
    };
    

    const table = {
        Data: detalles,
        Columns: [
            {
                field: 'IdDCustomer',
                header: 'ID',
                className: 'small',
                hidden: userAuth?.IdRol === 1,
                className: 'XXsmall',
            },

            {
                field: 'StatusName',
                header: 'Estado',
                className: 'Xsmall',
                Format: 'Template',
                Format: 'Estado',
                body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
                Sumary: 'count',
                editable: ({data}) => data?.IdDCustomer > 0,
                cellEditor: changeEstado,
            },
            {
                field: 'RTN',
                header: 'RTN',
                className: 'small',
                editable: true,
                onChange: (data) => changeValue(data),
            },
            {
                field: 'CompanyName',
                header: 'Compañia',
                className: 'large',
                editable: true,
                onChange: (data) => changeValue(data),
            },
            {
                field: 'Contact',
                header: 'Contact',
                className: 'medium',
                editable: true,
                onChange: (data) => changeValue(data),
            },
            {
                field: 'Tel',
                header: 'Tel',
                className: 'medium',
                editable: true,
                onChange: (data) => changeValue(data),
            },
            {
                field: 'Email',
                header: 'Email',
                className: 'medium',
                editable: true,
                onChange: (data) => changeValue(data),
            },
            // {
            //     field: 'Country',
            //     header: 'Country',
            //     className: 'medium',
            // },
            {
                field: 'CountryName',
                header: 'Country',
                className: 'medium',
                editable: true,
                cellEditor: changePais,
            },
            {
                field: 'City',
                header: 'City',
                className: 'small',
                editable: true,
                onChange: (data) => changeValue(data),
            },
            {
                field: 'State',
                header: 'State',
                className: 'medium',
                editable: true,
                onChange: (data) => changeValue(data),
            },
            {
                field: 'Address',
                header: 'Direccion',
                className: 'large',
                editable: true,
                onChange: (data) => changeValue(data),
            },
            {
                field: 'IsBuyer',
                header: 'IsBuyer',
                className: 'small',
                Format: "Template",
                align: "center",
                body: (rowData) => rowData?.IdDCustomer && (<Checkbox onChange={(e) => onChangeCheck(1, rowData.IdDCustomer, e.checked)} style={{ marginBottom: 5 }} checked={rowData.IsBuyer} />),
            },
            {
                field: 'IsShipTo',
                header: 'IsShipTo',
                className: 'small',
                Format: "Template",
                align: "center",
                body: (rowData) => rowData?.IdDCustomer && (<Checkbox onChange={(e) => onChangeCheck(2, rowData.IdDCustomer, e.checked)} style={{ marginBottom: 5 }} checked={rowData.IsShipTo} />),
            },
            {
                field: 'IsBillTo',
                header: 'IsBillTo',
                className: 'small',
                Format: "Template",
                align: "center",
                body: (rowData) =>  rowData?.IdDCustomer && (<Checkbox onChange={(e) => onChangeCheck(3, rowData.IdDCustomer, e.checked)} style={{ marginBottom: 5 }} checked={rowData.IsBillTo} />),
            },
            {
                field: 'ZipCode',
                header: 'ZipCode',
                className: 'medium',
                editable: true,
                onChange: (data) => changeValue(data),
            },
            // {
            //     header: 'Acciones',
            //     className: 'small',
            //     filter:false,
            //     body: (rowData) => botones(rowData),
            //     Format: "Template",
            //     frozen: 'true',
            //     alignFrozen: 'right',
            // }

        ],
        key: 'IdCustomerDetails ',
        selected: selected,
        setSelected: setSelected,
        // scrollHeight: '100%',
        
    }

    const agregarNuevaFila = () => {
        let newRowData = [...detalles];
    
        let IdDet = -(detalles?.length + 1);
        const newData = {
            IdDCustomer: IdDet,
            RTN: '',
            IdStatus: 1,
            StatusName: 'Active',
            CompanyName: '',
            Contact: '',
            Tel: '',
            Email: '',
            IdCountry: null,
            Country: '',
            City: '',
            State: '',
            Address: '',
            IsBuyer: false,
            IsShipTo: false,
            IsBillTo: false,
            ZipCode: ''
        };
    
        newRowData.push(newData);
        setDetalles(newRowData);
    };
    
    const GuardarDatos = async () => {
        const tieneRTNInvalido = detalles.some((detalle) => !detalle.RTN)
        const tieneCompanyNameInvalido = detalles.some((detalle) => !detalle.CompanyName)
        const tieneContactInvalido = detalles.some((detalle) => !detalle.Contact)
        const tieneTelInvalido = detalles.some((detalle) => !detalle.Tel)
        const tieneEmailInvalido = detalles.some((detalle) => !detalle.Email)
        const tieneCountryInvalido = detalles.some((detalle) => !detalle.COUNTRY)
        const tieneCityInvalida = detalles.some((detalle) => !detalle.City)
        const tieneStateInvalido = detalles.some((detalle) => !detalle.State)
        const tieneAddressInvalido = detalles.some((detalle) => !detalle.Address)

        if (tieneRTNInvalido) {
            toastShow(
                toast,
                "error",
                "Error",
                "Todos los detalles deben tener un RTN válido."
            );
            return;
        }
    
        if (tieneCompanyNameInvalido) {
            toastShow(
                toast,
                "error",
                "Error",
                "Todos los detalles deben tener un Nombre válido."
            );
            return;
        }

        if (tieneContactInvalido) {
            toastShow(
                toast,
                "error",
                "Error",
                "Todos los detalles deben tener un contacto válido."
            );
            return;
        }

        if (tieneTelInvalido) {
            toastShow(
                toast,
                "error",
                "Error",
                "Todos los detalles deben tener un Tel válido."
            );
            return;
        }
    
        if (tieneEmailInvalido) {
            toastShow(
                toast,
                "error",
                "Error",
                "Todos los detalles deben tener un Email válido."
            );
            return;
        }

    
        if (tieneCountryInvalido) {
            toastShow(
                toast,
                "error",
                "Error",
                "Todos los detalles deben tener un COUNTRY válido."
            );
            return;
        }
    
        if (tieneCityInvalida) {
            toastShow(
                toast,
                "error",
                "Error",
                "Todos los detalles deben tener una City válida."
            );
            return;
        }
    
        if (tieneStateInvalido) {
            toastShow(
                toast,
                "error",
                "Error",
                "Todos los detalles deben tener un State válido."
            );
            return;
        }
    
        if (tieneAddressInvalido) {
            toastShow(
                toast,
                "error",
                "Error",
                "Todos los detalles deben tener una Address válida."
            );
            return;
        }

        setLoading(true)
        const Datos = detalles.map((detalle) => ({
            ...detalle,
            IdCustomer: IdCustomer,
            IdUserCreate: userAuth?.idUser,
            IdUserEdit: userAuth?.idUser,
        }));
    
        let todosGuardadosExitosamente = true; 

        for (const detalle of Datos) {
            const resp = await GuardarCustomerDetails(detalle);
    
            if (resp[0]?.ESTADO !==1) {
                todosGuardadosExitosamente = false;
            }
        }
    
        if (todosGuardadosExitosamente) {
            toastShow( toast, "success", "Guardado", "Datos guardados correctamente");
            getInfo()
        } else {
            toastShow( toast, "error", "Error", "Error al guardar datos.");
        }
        setLoading(false)
    }
    

    const hideDialog = () => {
        setClientesDetailsDialog(false)
    }

    useEffect(() => {
        if (clientesDetailsDialog) {
            getInfo(IdCustomer);
        }
      }, [clientesDetailsDialog]);
    


    return (
      // <Fragment>
      //     <Button className='p-button-rounded p-button-info p-button-text' icon='ri-file-user-line' style={{ color: "black" }} onClick={openNew} />
      //     <Dialog visible={clientesDetailsDialog} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '80vw', height: '40vw' }}
      //         onHide={hideDialog}  header ="COMPRADORES FINALES"  >
      //         <Loader loading={loading} />
      //         <Card
      //             titulo={<div className="d-flex">
      //                 {/* <h3 className="mx-3">Compradores Finales</h3> */}
      //                 <ModalAEClientesDetalle
      //                     toast={toast}
      //                     icono={aspectoBoton[0].Icono}
      //                     nombre={aspectoBoton[0].Nombre}
      //                     className={aspectoBoton[0].className}
      //                     obtenerCustomerDetails={obtenerCustomerDetails}
      //                     // clienteDetalleDialog={clienteDetalleDialog}
      //                     // setClienteDetalleDialog={ setClienteDetalleDialog}
      //                     onClick={true}
      //                 />
      //                 <Button className="p-button-text p-button-rounded mx-2" icon="ri-restart-line" loading={loading} onClick={obtenerCustomerDetails} />
      //             </div>}
      //             contenido={
      //                 <div className='pt-4' style={{ height: '60vh' }}>
      //                     <Toast position="bottom-right" ref={toast} />

      //                     <AgGrid table={table} />
      //                 </div>
      //             }
      //         />
      //     </Dialog>
      // </Fragment>

      <Dialog
        visible={clientesDetailsDialog}
        breakpoints={{ "960px": "75vw", "640px": "100vw" }}
        style={{ width: "80vw", height: "40vw" }}
        onHide={hideDialog}
        header="Compradores Finales"
      >
        <Toast ref={toast} />
        <Loader loading={loading} />
        <Card
          titulo={
            <div className="d-flex gap-2">
              {/* <h3 className="mx-3">Compradores Finales</h3> */}
              {/* <ModalAEClientesDetalle
                toast={toast}
                icono={aspectoBoton[0].Icono}
                nombre={aspectoBoton[0].Nombre}
                className={aspectoBoton[0].className}
                obtenerCustomerDetails={obtenerCustomerDetails}
                // clienteDetalleDialog={clienteDetalleDialog}
                // setClienteDetalleDialog={ setClienteDetalleDialog}
                onClick={true}
              /> */}
                <Button
                    icon="pi pi-plus"
                    tooltip="Nuevo"
                    onClick={agregarNuevaFila}
                />
                <Button
                    icon="ri-restart-line"
                    tooltip="Recargar"
                    onClick={getInfo}
                />
                <Button
                    icon="pi pi-save"
                    tooltip="Guardar"
                    onClick={GuardarDatos}
                />
            </div>
          }
          contenido={
            <div className="pt-4" style={{ height: "65vh" }}>
            

              <AgGrid table={table} />
            </div>
          }
        />
      </Dialog>
    );
}

export default ModalClientesDetails